module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="sorting-panel-region"></div>\n<div class="content collection"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/imageLibrary/ImageLibraryCollectionView.tpl
// module id = 1740
// module chunks = 0